import React, { useState } from 'react';
import { UseGlobellogin } from './component/Logincontaxt.jsx/Logincontex';
import styled from 'styled-components';

function Forgetpassword({ setIsForgotPassword }) {
  const [email, setdata] = useState('');
  const {setsuccessfully , successfully } = UseGlobellogin();
  const [Error, setErrormsg] = useState();
  const [loading , setloading] = useState(false);

  const updateInput = (event) => {
    const value = event.target.value;
        setdata(value);
  };

  const submitform = async (e) => {
    e.preventDefault();
       setloading(true);
    try {
      const response = await fetch('http://localhost:3001/api/auth/Forgetpassword', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }), // Wrap the email in an object
      });

      const responseData = await response.json();
      if (response.ok) {
        setloading(false);
        setsuccessfully(responseData.message);
      setTimeout(() => setsuccessfully(''), 7000);
        setdata("")
      } else {
        setErrormsg(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
    <Wrapper>
      <div className="col-12 col-lg-12 mb-4 mb-lg-0">
         <div className="login-card p-4 p-md-5 h-100 d-flex flex-column justify-content-center">
      <form onSubmit={submitform}>
      {/* {successfully && (
            <div style={{color:'green', fontSize:'1rem'}}>{successfully}</div>
            )} */}
        <div className="form-floating mb-3">
          {/* <label htmlFor="reset-email">Enter your email to reset password:</label> */}
          <input
            type="email"
            id="reset-email"
            className='form-control'
            placeholder="Enter your email "
            value={email}
            onChange={updateInput}
            required
          />
        <label htmlFor="user_input">Enter your email </label>
        </div>

        <button type="submit" className="th-btn style3" disabled={loading}>

        {loading ? (
          <span className="spinner">
            {/* Replace this with an actual spinner if needed */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="16"
              height="16"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 2v4"></path>
            </svg>   
          </span>
        ) 
        : (
          "Reset Password" 
        )}<i className="fas fa-arrow-right ms-2" />
      </button>
        {Error && (
          <div
            className="form-message"
            style={{
              color: 'red',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            {Error}
          </div>
        )}
         
        <div
          style={{ marginTop: '12px', cursor: 'pointer', color: 'blue' }}
          onClick={() => setIsForgotPassword(false)}
        >
          Back to Login
        </div>
      </form>
      </div>
      </div>
      


      </Wrapper>
    </>
  );
}

const Wrapper = styled.section`
 .login-card {
    transition: all 0.5s ease-in-out;
    border: 1px solid #b3cae0ff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border-radius: 12px;
  }

  .login-card:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-8px);
  }

  .login-card input:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  }

  .login-card .th-btn {
    transition: background-color 0.4s ease, transform 0.3s;
  }

  .login-card .th-btn:hover {
    background-color: #084298;
    transform: translateY(-2px);
  }

`;
export default Forgetpassword;
